<template>
  <div class="users content-container flex-column">
    <div class="content-wrap">

      <!-- Sekcja główna historii aktywności użytkowników -->
      <div class="d-flex users-section-container">
        <div class="users-section">
          <span>
            {{ t('users-activity-history') }}
          </span>
        </div>
        <div class="content-wrap">
          <h3>
            {{ t('users-activity-history').toUpperCase() }}
            <!--
              Raport (ZIP z plikiem CSV) dla kryteriów ostatniego wyszukiwania.
              Aktywny dopiero po kliknięciu „Szukaj” — bez tego nie wiadomo, co raportować.
            -->
            <button
              class="btn btn-download"
              @click="retrieveReport"
              :disabled="isDownloading || !filtersStore.applied"
              :title="filtersStore.applied ? '' : t('activity-search-hint')"
            >
              <span>CSV</span>
            </button>
          </h3>
          <div class="collapse show" id="userHistory">
            <!-- Komponent wyświetlający historię aktywności użytkowników -->
            <UserActivityList />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useI18n } from 'vue-i18n'
import UserActivityList from "@/components/UserActivityList";
import Users from "@/services/Users";
import { useUserActivityFiltersStore } from "@/stores/userActivityFilters";

export default {
  name: "UsersActivityView",
  components: {
    UserActivityList,
  },
  setup() {
    const { t } = useI18n()
    return { t, filtersStore: useUserActivityFiltersStore() }
  },
  data() {
    return {
      isDownloading: false,
    };
  },
  methods: {
    /**
     * Generuje i pobiera raport dla kryteriów ostatniego wyszukiwania.
     */
    async retrieveReport() {
      const criteria = this.filtersStore.applied;
      if (!criteria) {
        return;
      }

      this.isDownloading = true;

      try {
        const data = await Users.getActivityReport(criteria);
        const response = await Users.fetch(data.link);

        const link = document.createElement("a");
        link.href = URL.createObjectURL(response);
        link.download = "user_logs";
        link.click();
        URL.revokeObjectURL(link.href);
      } catch (e) {
        console.error(e);
      } finally {
        this.isDownloading = false;
      }
    },
  },
};
</script>

<style scoped>
.users-section-container {
  width: 100%;
}

.users-section {
  width: var(--sidebar-width);
  background: var(--surface-secondary);
}

.users-section > span {
  padding: var(--spacing-md) var(--spacing-lg);
  position: relative;
  display: block;
}

.content-wrap h3 {
  background-color: var(--surface-primary);
  padding: var(--spacing-md) var(--spacing-lg);
  margin-bottom: 0;
  position: relative;
}

h3 button {
  position: absolute;
  right: 20px;
  top: 17%;
  background-color: var(--surface-selected);
  cursor: pointer;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 100px;
  min-height: 28px;
  font-weight: var(--font-weight-regular);
  padding: 0;
  border: 0;
  font-size: var(--font-size-sm);
}

h3 button[disabled] {
  cursor: not-allowed;
  opacity: 0.5;
}

.no-content {
  min-height: auto;
}
.btn-download:hover:not([disabled]) {
  background-color: var(--border-default);
}
</style>
